<template>
  <div class="otp-wrap">
    <!-- ONE input, not one per digit. The old per-digit boxes were keyed on
         their VALUE, so every keystroke re-created the focused input and
         mobile keyboards (Samsung especially) closed after each digit; they
         also relied on event.key, which virtual keyboards often report as
         "Unidentified". A single numeric field is what OS-level OTP autofill
         (SMS/email one-time-code) expects, too. -->
    <input
      ref="otpInput"
      type="text"
      name="otp_input"
      class="otp-input"
      inputmode="numeric"
      pattern="[0-9]*"
      autocomplete="one-time-code"
      :maxlength="digitCount"
      :placeholder="placeholder"
      :value="value"
      autofocus
      @input="onInput"
      @paste="onPaste"
    >
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
// eslint-disable-next-line
const props = defineProps({
  default: String,

  digitCount: {
    type: Number,
    required: true
  }
});

// eslint-disable-next-line
const emit = defineEmits(['update:otp']);

const value = ref((props.default || '').replace(/\D/g, '').slice(0, props.digitCount));
const otpInput = ref(null);
const placeholder = computed(() => '•'.repeat(props.digitCount));

const setValue = function (raw) {
  const digits = String(raw || '').replace(/\D/g, '').slice(0, props.digitCount);
  value.value = digits;
  // Keep the DOM in sync when we strip non-digits (input event already fired).
  if (otpInput.value && otpInput.value.value !== digits) {
    otpInput.value.value = digits;
  }
  // Emit on every change so the Confirm button enables at exactly N digits
  // and disables again on backspace.
  emit('update:otp', digits);
};

const onInput = function (event) {
  setValue(event.target.value);
};

const onPaste = function (event) {
  const text = (event.clipboardData || window.clipboardData)?.getData('text') || '';
  if (text) {
    event.preventDefault();
    setValue(text);
  }
};

onMounted(() => {
  if (otpInput.value) {
    otpInput.value.focus();
  }
});
</script>

<style scoped>
.otp-wrap {
  width: 100%;
}
.otp-input {
  width: 100%;
  max-width: 22rem;
  height: 4rem;
  border: 1px solid #bbb;
  border-radius: 5px;
  padding: 0 1rem;
  font-size: 2.4rem;
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  letter-spacing: 0.6em;
  text-align: center;
  background: #fff;
  color: #222;
}
.otp-input::placeholder {
  color: #ccc;
  letter-spacing: 0.6em;
}
.otp-input:focus {
  outline: 2px solid #3880ff;
  border-color: #3880ff;
}
</style>
